import client, { services } from '../../core/feathers'
import {
  cleanCheckouts,
  fetchPendingCheckouts,
  storeCheckouts,
  storeCheckoutItems
} from './actions'
import {
  CHECKOUT_CREATED,
  CHECKOUT_PATCHED,
  CHECKOUT_ITEM_CREATED,
  CHECKOUT_ITEM_PATCHED
} from './constants'

export default function checkoutListeners(dispatch, getState) {
  client.on('login', userId => {
    dispatch(fetchPendingCheckouts())
  })
  client.on('logout', () => {
    dispatch(cleanCheckouts())
  })
  services.checkout.on('created', checkout => {
    dispatch(storeCheckouts([checkout], CHECKOUT_CREATED))
  })
  services.checkout.on('patched', checkout => {
    dispatch(storeCheckouts([checkout], CHECKOUT_PATCHED))
  })
  services.checkoutItem.on('created', checkoutItem => {
    dispatch(storeCheckoutItems([checkoutItem], CHECKOUT_ITEM_CREATED))
  })
  services.checkoutItem.on('patched', checkoutItem => {
    dispatch(storeCheckoutItems([checkoutItem], CHECKOUT_ITEM_PATCHED))
  })
}



// WEBPACK FOOTER //
// ./src/services/checkout/listeners.js